import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppleSoftwareLookupServiceService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  AvailableLookupOsUpdateApiActions,
  AvailableLookupOsUpdateResolverActions,
} from './available-lookup-os-update.actions';

@Injectable()
export class AvailableLookupOsUpdateEffects {
  constructor(
    private readonly actions: Actions,
    private readonly appleLookupService: AppleSoftwareLookupServiceService
  ) {}

  availableLookupOsUpdateRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(AvailableLookupOsUpdateResolverActions.availableLookupOSUpdatesRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleLookupService.getAvailableLookupOsUpdatesForDevice(udid, '2.0'),
          (availableLookupOsUpdates) =>
            AvailableLookupOsUpdateApiActions.availableLookupOSUpdatesLoaded({
              availableLookupOsUpdates: availableLookupOsUpdates.map((availableLookupOsUpdate) => ({
                ...availableLookupOsUpdate,
                udid,
              })),
            }),
          (error) =>
            AvailableLookupOsUpdateApiActions.availableLookupOSUpdatesLoadedError({
              error,
            })
        )
      )
    );
  });
}
